import styled from "styled-components";

interface IProps {
  color?: React.CSSProperties["color"];
  background?: React.CSSProperties["background"];
}
export const Styles = styled.div<IProps>`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  .item_info {
    white-space: nowrap;
    color: #1e3666;
    padding: 5px 0;
    width: 100%;
    .label {
      white-space: nowrap;
    }
  }

  .signed_info_grid {
    display: grid;
    grid-template-columns: max-content max-content;
    gap: 5px 20px;
    width: fit-content;
    color: #1e3666;

    &__label {
      white-space: nowrap;
    }

    &__value {
      display: flex;
      align-items: center;
      justify-content: center;
      white-space: nowrap;
      text-align: center;
      justify-self: center;
    }
  }
`;
